const applicationSlug = String(process.env.VUE_APP_APPLICATION || '').trim().toLowerCase()
const configuredApplicationLabel = String(process.env.VUE_APP_TITLE || '').trim()
const defaultApplicationLabels = {
  maviepro: 'Maviepro',
  merlin: 'Merlin',
  tract: 'Tract'
}

export const INTERNAL_MEDIA_LABEL = `Média ${configuredApplicationLabel || defaultApplicationLabels[applicationSlug] || 'Maviepro'}`
